import Vue from 'vue';
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
    'en': {
        metaDesc:"Acca Digital - Website, AR, VR and Digital Infrastructure Solutions",        

        // Menu Items:
        
        menu1: "Home",
        menu2: "Experiences",
        menu3: "Services",
        menu4: "Contact",

        // Hero Section Texts: 

        heroTitle: 'Solutions for the future.',
        heroMessage: "We create cutting edge digital tools to represent your brand and super charge your productivity.",

        // "Experiences" section texts:

        experiencesTitle: "The Future... Now.",
        experiencesText: "The world is changing, and so is the web.",
        experiencesText2: "We can provide innovative experiences that will set your products, services and company apart. To get a taste of we create, you can take a look at our AR services and experience our models in your living spaces.",
        experiencesButton: "Get More Information",

        // Services section texts:

        title1: "Web",
        text1: "Beautiful, fast, responsive websites and web apps.",
        title2: "Applications",
        text2: "Applications for the Apple ecosystem, including iOS.",
        title3: "AR Solutions",
        text3: "Products and services brought to life with Augmented Reality.",
        title4: "VR Solutions",
        text4: "Immersive Virtual Reality experiences for corporate needs.",
        title5: "Website Optimization",
        text5: "Speed, performance and SEO optimization for your existing websites.",
        title6: "Scraping & Automation",
        text6: "Automation of your of daily, routine and repeated tasks.",
        title7: "Digital Documents",
        text7: "Simple and interactive digital documents for all your needs.",
        title8: "Infrastructure & Consulting",
        text8: "Software consulting for your company's digital transformation.",

        // Contact Texts:

        contactTitle: "Let's get in touch.",
        contactText: "We're always happy to listen to your projects and brainstorm about what we can achieve together. To get more information about our services, references and rates, you can contact us at your convenience.",
        contactButton: "Contact Us",


    },
    'tr': {
        metaDesc:"Acca Digital - Web Sitesi, AR, VR ve Dijital Altyapı Çözümleri",        

        // Menu Items:
        
        menu1: "Giriş",
        menu2: "Deneyimler",
        menu3: "Hizmetler",
        menu4: "İletişim",

        // Hero Section Texts: 

        heroTitle: 'Şirketinizi geleceğe hazırlayın.',
        heroMessage: "Markanızı en iyi temsil edecek, şirket içi üretkenliğinizi arttıracak yenilikçi çözümler üretiyoruz.",

        // "Experiences" section texts:

        experiencesTitle: "Gelecek için... Bugün.",
        experiencesText: "Dünya her geçen gün değişiyor - ve dijital platformlar bu değişimden çok hızlı bir şekilde etkileniyor.",
        experiencesText2: "Bu süreçte, şirketinizi, ürünlerinizi ve hizmetlerinizi öne çıkartacak yaratıcı çözümler sunabiliriz. Aşağıdaki bağlantıya tıklayarak, sunduğumuz Artırılmış Gerçeklik (AR) hizmeti hakkında daha detaylı bilgi alabilir, örnek modellerimizi kendi yaşam alanlarınızda deneyimleyebilirsiniz.",
        experiencesButton: "Detaylı Bilgi Alın.",

        // Services section texts:

        title1: "Web",
        text1: "Estetik, hızlı ve yüksek performanslı web siteleri ve web uygulamaları.",
        title2: "Uygulama",
        text2: "iPhone ve iPad dahil, Apple ekosistemi için uygulamalar.",
        title3: "AR Çözümleri",
        text3: "Ürün ve hizmetleriniz için Artırışmış Gerçeklik çözümleri.",
        title4: "VR Çözümleri",
        text4: "Kurumsal ihtiyaçlar için gerçekçi Sanal Gerçeklik deneyimleri.",
        title5: "Website Optimizasyonu",
        text5: "Mevcut web sitelerinizin teknik, hız ve SEO optimizasyonu.",
        title6: "Dijital Otomasyon Çözümleri",
        text6: "Günlük, rutin ve tekrarlayan işlerinizin otomatik hale getirilmesi.",
        title7: "Digital Belge Üretimi",
        text7: "Basit ve interaktif dijital belge üretimi.",
        title8: "Altyapı ve Danışmanlık",
        text8: "Şirketinizin dijital dönüşümü çin altyapı ve yazılım danışmanlığı.",

        // Contact Texts:

        contactTitle: "İletişime geçin.",
        contactText: "İhtiyaçlarınızı dinlemek ve birlikte ne gibi çözümler üretebileceğimizi konuşmaktan mutluluk duyarız. Hizmet alanlarımız, referanslarımız ve ücretlerimiz için bize her zaman aşağıdaki bağlantıyı kullanarak mail gönderebilirsiniz.",
        contactButton: "İletişime Geçin.",
    }
};




const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'tr', 
    messages: messages,
})

export default i18n;

/* eslint-disable no-unused-vars */

/* eslint-disable no-unused-vars */